import * as types from './actionTypes';
import {ajaxCallError} from './ajaxStatusActions';
import {Api} from '../api/Api';
import {beginAjaxCall, sinReducerSuccess} from './ajaxStatusActions';



export function saveAdjunto(datos,token ) {
  return dispatch => {
	dispatch(beginAjaxCall());  
    return Api().ConstanciaExternaApi.saveAdjunto(datos, token).then(() => {                   
        dispatch(sinReducerSuccess());        
    }).catch(error => {
		dispatch(ajaxCallError()); 
      throw(error);
    });
  };
}